export type AnnouncementAudienceSizes = {
  __typename?: 'AnnouncementAudienceSizes';
  locationId: string;
  employeeAudienceCount: {
    self: number;
    allEmployeesCheckedIn: number;
    allEmployeesAtLocation: number;
    allEmployeesAtDefaultLocation: number;
    allEmployeesWithReservation: number;
  };
  visitorAudienceCount: {
    allVisitorsCheckedIn: number;
    allVisitorsSignedOut: number;
    allVisitorsWithReservation: number;
  };
};

export type GetAnnouncementAudienceSizesQuery = {
  __typename?: 'Query';
  announcementAudienceSizes: AnnouncementAudienceSizes[];
};

export type GetAnnouncementAudienceSizesVariables = {
  locationId: string;
};

export type PopulateAnnouncementTemplate = {
  __typename?: 'PopulateAnnouncementTemplate';
  defaultEmployeeAudiences: string[];
  defaultVisitorAudiences: string[];
  defaultChannels: string[];
  id: string;
  message: string;
  title: string;
  markAsSafe: boolean;
};

export type PopulateAnnouncementTemplateQuery = {
  __typename?: 'Query';
  populateAnnouncementTemplate: PopulateAnnouncementTemplate;
};

export type PopulateAnnouncementTemplateVariables = {
  locationId: string;
  announcementTemplateId: string;
};

export type GetAnnouncementTemplateNamesForLocationByCategoryQuery = {
  __typename?: 'Query';
  announcementTemplateNamesForLocationByCategory: AnnouncementTemplateNamesForLocationByCategory[];
};

export type GetAnnouncementTemplateNamesForLocationByCategoryVariables = {
  locationId: string;
};

export type AnnouncementTemplateNamesForLocationByCategory = {
  __typename?: 'AnnouncementTemplateNamesForLocationByCategory';
  id: string;
  name: string;
  templates: {
    id: string;
    name: string;
  }[];
};

export type CreateAnnouncement = {
  __typeName?: 'Announcement';
  id: string;
  statistics: {
    sentCount: {
      employeesCount: number;
      visitorsCount: number;
    };
  };
};

export type CreateAnnouncementMutation = {
  __typename?: 'Mutation';
  createAnnouncement: CreateAnnouncement;
};

export type CreateAnnouncementVariables = {
  announcementInput: {
    message: string;
    title?: string;
    type: 'ANNOUNCEMENT' | 'EMERGENCY';
    actions: 'MARK AS SAFE'[];
    audiences: {
      locationId: string;
      type: string;
    }[];
    channels: 'SMS' | 'PUSH_NOTIFICATION' | 'EMAIL';
  };
};

export type Location = {
  __typename?: 'Location';
  id: string;
  name: string;
};

export type GetSkinnyLocationsQuery = {
  __typename?: 'Query';
  locations: Location[];
};

export type GetSkinnyLocationsVariables = {};
